var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"green"}}):_c('span',[_vm._v(" "+_vm._s(_vm.saldo)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }